import { render } from "./RegisterOffice.vue?vue&type=template&id=fe888ea8"
import script from "./RegisterOffice.vue?vue&type=script&lang=js"
export * from "./RegisterOffice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__